import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../wayfinder'
/**
* @see routes/web.php:123
* @route 'https://pokor.dev/robots.txt'
*/
export const robots = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: robots.url(options),
    method: 'get',
})

robots.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/robots.txt',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:123
* @route 'https://pokor.dev/robots.txt'
*/
robots.url = (options?: RouteQueryOptions) => {
    return robots.definition.url + queryParams(options)
}

/**
* @see routes/web.php:123
* @route 'https://pokor.dev/robots.txt'
*/
robots.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: robots.url(options),
    method: 'get',
})

/**
* @see routes/web.php:123
* @route 'https://pokor.dev/robots.txt'
*/
robots.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: robots.url(options),
    method: 'head',
})

/**
* @see routes/web.php:130
* @route 'https://pokor.dev/llms.txt'
*/
export const llms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: llms.url(options),
    method: 'get',
})

llms.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/llms.txt',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:130
* @route 'https://pokor.dev/llms.txt'
*/
llms.url = (options?: RouteQueryOptions) => {
    return llms.definition.url + queryParams(options)
}

/**
* @see routes/web.php:130
* @route 'https://pokor.dev/llms.txt'
*/
llms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: llms.url(options),
    method: 'get',
})

/**
* @see routes/web.php:130
* @route 'https://pokor.dev/llms.txt'
*/
llms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: llms.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LandingController::landing
* @see app/Http/Controllers/LandingController.php:16
* @route 'https://pokor.dev'
*/
export const landing = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: landing.url(options),
    method: 'get',
})

landing.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LandingController::landing
* @see app/Http/Controllers/LandingController.php:16
* @route 'https://pokor.dev'
*/
landing.url = (options?: RouteQueryOptions) => {
    return landing.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\LandingController::landing
* @see app/Http/Controllers/LandingController.php:16
* @route 'https://pokor.dev'
*/
landing.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: landing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LandingController::landing
* @see app/Http/Controllers/LandingController.php:16
* @route 'https://pokor.dev'
*/
landing.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: landing.url(options),
    method: 'head',
})

/**
* @see routes/web.php:143
* @route 'https://pokor.dev/privacy'
*/
export const privacy = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

privacy.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/privacy',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:143
* @route 'https://pokor.dev/privacy'
*/
privacy.url = (options?: RouteQueryOptions) => {
    return privacy.definition.url + queryParams(options)
}

/**
* @see routes/web.php:143
* @route 'https://pokor.dev/privacy'
*/
privacy.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: privacy.url(options),
    method: 'get',
})

/**
* @see routes/web.php:143
* @route 'https://pokor.dev/privacy'
*/
privacy.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: privacy.url(options),
    method: 'head',
})

/**
* @see routes/web.php:144
* @route 'https://pokor.dev/terms'
*/
export const terms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

terms.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/terms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:144
* @route 'https://pokor.dev/terms'
*/
terms.url = (options?: RouteQueryOptions) => {
    return terms.definition.url + queryParams(options)
}

/**
* @see routes/web.php:144
* @route 'https://pokor.dev/terms'
*/
terms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

/**
* @see routes/web.php:144
* @route 'https://pokor.dev/terms'
*/
terms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: terms.url(options),
    method: 'head',
})

/**
* @see routes/web.php:145
* @route 'https://pokor.dev/faq'
*/
export const faq = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

faq.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/faq',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:145
* @route 'https://pokor.dev/faq'
*/
faq.url = (options?: RouteQueryOptions) => {
    return faq.definition.url + queryParams(options)
}

/**
* @see routes/web.php:145
* @route 'https://pokor.dev/faq'
*/
faq.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: faq.url(options),
    method: 'get',
})

/**
* @see routes/web.php:145
* @route 'https://pokor.dev/faq'
*/
faq.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: faq.url(options),
    method: 'head',
})

/**
* @see routes/web.php:146
* @route 'https://pokor.dev/changelog'
*/
export const changelog = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: changelog.url(options),
    method: 'get',
})

changelog.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/changelog',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:146
* @route 'https://pokor.dev/changelog'
*/
changelog.url = (options?: RouteQueryOptions) => {
    return changelog.definition.url + queryParams(options)
}

/**
* @see routes/web.php:146
* @route 'https://pokor.dev/changelog'
*/
changelog.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: changelog.url(options),
    method: 'get',
})

/**
* @see routes/web.php:146
* @route 'https://pokor.dev/changelog'
*/
changelog.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: changelog.url(options),
    method: 'head',
})

/**
* @see routes/web.php:147
* @route 'https://pokor.dev/pricing'
*/
export const pricing = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pricing.url(options),
    method: 'get',
})

pricing.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/pricing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:147
* @route 'https://pokor.dev/pricing'
*/
pricing.url = (options?: RouteQueryOptions) => {
    return pricing.definition.url + queryParams(options)
}

/**
* @see routes/web.php:147
* @route 'https://pokor.dev/pricing'
*/
pricing.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pricing.url(options),
    method: 'get',
})

/**
* @see routes/web.php:147
* @route 'https://pokor.dev/pricing'
*/
pricing.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pricing.url(options),
    method: 'head',
})

/**
* @see routes/web.php:148
* @route 'https://pokor.dev/features'
*/
export const features = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: features.url(options),
    method: 'get',
})

features.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/features',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:148
* @route 'https://pokor.dev/features'
*/
features.url = (options?: RouteQueryOptions) => {
    return features.definition.url + queryParams(options)
}

/**
* @see routes/web.php:148
* @route 'https://pokor.dev/features'
*/
features.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: features.url(options),
    method: 'get',
})

/**
* @see routes/web.php:148
* @route 'https://pokor.dev/features'
*/
features.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: features.url(options),
    method: 'head',
})

/**
* @see routes/web.php:149
* @route 'https://pokor.dev/ai'
*/
export const ai = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ai.url(options),
    method: 'get',
})

ai.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/ai',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:149
* @route 'https://pokor.dev/ai'
*/
ai.url = (options?: RouteQueryOptions) => {
    return ai.definition.url + queryParams(options)
}

/**
* @see routes/web.php:149
* @route 'https://pokor.dev/ai'
*/
ai.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ai.url(options),
    method: 'get',
})

/**
* @see routes/web.php:149
* @route 'https://pokor.dev/ai'
*/
ai.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ai.url(options),
    method: 'head',
})

/**
* @see routes/web.php:150
* @route 'https://pokor.dev/about'
*/
export const about = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

about.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/about',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:150
* @route 'https://pokor.dev/about'
*/
about.url = (options?: RouteQueryOptions) => {
    return about.definition.url + queryParams(options)
}

/**
* @see routes/web.php:150
* @route 'https://pokor.dev/about'
*/
about.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: about.url(options),
    method: 'get',
})

/**
* @see routes/web.php:150
* @route 'https://pokor.dev/about'
*/
about.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: about.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ContactController::contact
* @see app/Http/Controllers/ContactController.php:12
* @route 'https://pokor.dev/contact'
*/
export const contact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

contact.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/contact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ContactController::contact
* @see app/Http/Controllers/ContactController.php:12
* @route 'https://pokor.dev/contact'
*/
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactController::contact
* @see app/Http/Controllers/ContactController.php:12
* @route 'https://pokor.dev/contact'
*/
contact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactController::contact
* @see app/Http/Controllers/ContactController.php:12
* @route 'https://pokor.dev/contact'
*/
contact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contact.url(options),
    method: 'head',
})

/**
* @see routes/web.php:163
* @route 'https://pokor.dev/security'
*/
export const security = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(options),
    method: 'get',
})

security.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/security',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:163
* @route 'https://pokor.dev/security'
*/
security.url = (options?: RouteQueryOptions) => {
    return security.definition.url + queryParams(options)
}

/**
* @see routes/web.php:163
* @route 'https://pokor.dev/security'
*/
security.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: security.url(options),
    method: 'get',
})

/**
* @see routes/web.php:163
* @route 'https://pokor.dev/security'
*/
security.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: security.url(options),
    method: 'head',
})

/**
* @see routes/web.php:164
* @route 'https://pokor.dev/trust'
*/
export const trust = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: trust.url(options),
    method: 'get',
})

trust.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/trust',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:164
* @route 'https://pokor.dev/trust'
*/
trust.url = (options?: RouteQueryOptions) => {
    return trust.definition.url + queryParams(options)
}

/**
* @see routes/web.php:164
* @route 'https://pokor.dev/trust'
*/
trust.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: trust.url(options),
    method: 'get',
})

/**
* @see routes/web.php:164
* @route 'https://pokor.dev/trust'
*/
trust.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: trust.url(options),
    method: 'head',
})

/**
* @see routes/web.php:168
* @route 'https://pokor.dev/status'
*/
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: 'https://pokor.dev/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:168
* @route 'https://pokor.dev/status'
*/
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see routes/web.php:168
* @route 'https://pokor.dev/status'
*/
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

/**
* @see routes/web.php:168
* @route 'https://pokor.dev/status'
*/
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:22
* @route 'https://app.pokor.dev'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:22
* @route 'https://app.pokor.dev'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:22
* @route 'https://app.pokor.dev'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DashboardController::dashboard
* @see app/Http/Controllers/DashboardController.php:22
* @route 'https://app.pokor.dev'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AuthController::logout
* @see app/Http/Controllers/AuthController.php:221
* @route 'https://app.pokor.dev/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: 'https://app.pokor.dev/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthController::logout
* @see app/Http/Controllers/AuthController.php:221
* @route 'https://app.pokor.dev/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthController::logout
* @see app/Http/Controllers/AuthController.php:221
* @route 'https://app.pokor.dev/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SettingsController::settings
* @see app/Http/Controllers/SettingsController.php:33
* @route 'https://app.pokor.dev/settings'
*/
export const settings = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

settings.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev/settings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SettingsController::settings
* @see app/Http/Controllers/SettingsController.php:33
* @route 'https://app.pokor.dev/settings'
*/
settings.url = (options?: RouteQueryOptions) => {
    return settings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SettingsController::settings
* @see app/Http/Controllers/SettingsController.php:33
* @route 'https://app.pokor.dev/settings'
*/
settings.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: settings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SettingsController::settings
* @see app/Http/Controllers/SettingsController.php:33
* @route 'https://app.pokor.dev/settings'
*/
settings.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: settings.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ApiDashboardController::apiDashboard
* @see app/Http/Controllers/ApiDashboardController.php:13
* @route 'https://app.pokor.dev/dev/api-keys'
*/
export const apiDashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: apiDashboard.url(options),
    method: 'get',
})

apiDashboard.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev/dev/api-keys',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ApiDashboardController::apiDashboard
* @see app/Http/Controllers/ApiDashboardController.php:13
* @route 'https://app.pokor.dev/dev/api-keys'
*/
apiDashboard.url = (options?: RouteQueryOptions) => {
    return apiDashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ApiDashboardController::apiDashboard
* @see app/Http/Controllers/ApiDashboardController.php:13
* @route 'https://app.pokor.dev/dev/api-keys'
*/
apiDashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: apiDashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ApiDashboardController::apiDashboard
* @see app/Http/Controllers/ApiDashboardController.php:13
* @route 'https://app.pokor.dev/dev/api-keys'
*/
apiDashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: apiDashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ReadinessController::__invoke
* @see app/Http/Controllers/ReadinessController.php:11
* @route '/ready'
*/
export const ready = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ready.url(options),
    method: 'get',
})

ready.definition = {
    methods: ["get","head"],
    url: '/ready',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ReadinessController::__invoke
* @see app/Http/Controllers/ReadinessController.php:11
* @route '/ready'
*/
ready.url = (options?: RouteQueryOptions) => {
    return ready.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ReadinessController::__invoke
* @see app/Http/Controllers/ReadinessController.php:11
* @route '/ready'
*/
ready.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ready.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ReadinessController::__invoke
* @see app/Http/Controllers/ReadinessController.php:11
* @route '/ready'
*/
ready.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ready.url(options),
    method: 'head',
})

